import { useCallback } from "react";

import { useActivationSetFavicons } from "../../hooks/useActivationSetFavicons";
import { AlertsFeed } from "../AlertsFeed";
import { Virtualized } from "../Virtualized";

import { SocialPostModal } from "./components/social-post-modal/SocialPostModal";
import { SocialPostsAlert } from "./components/social-posts-alert/SocialPostsAlert";
import { useSocialAlertsQuery } from "./useSocialAlertsQuery";

export const SocialAlertsFeed = () => {
    const { data: socialAlertGroups = [], isLoading: isDataLoading } = useSocialAlertsQuery();
    const { favicons, isLoading: isFaviconsLoading } = useActivationSetFavicons();

    const getItemKey = useCallback(
        (index: number) => {
            const group = socialAlertGroups[index];
            return `${group.domain}-${group.socialMediaChannel}-${index}`;
        },
        [socialAlertGroups],
    );

    return (
        <>
            <AlertsFeed
                isLoading={isDataLoading || isFaviconsLoading}
                isEmpty={!socialAlertGroups.length}
            >
                <Virtualized
                    count={socialAlertGroups.length}
                    getItemKey={getItemKey}
                    renderItem={(index) => {
                        const group = socialAlertGroups[index];
                        return (
                            <SocialPostsAlert
                                groupIndex={index}
                                favicon={favicons?.[group.domain] ?? ""}
                                channel={group.socialMediaChannel}
                                domain={group.domain}
                                posts={group.posts}
                                totalPostsCount={group.postsCount}
                            />
                        );
                    }}
                />
            </AlertsFeed>
            <SocialPostModal
                favicons={favicons}
                groups={socialAlertGroups}
            />
        </>
    );
};
